import React from 'react';
import SMReputationListView from 'components/reputations/SMReputationListView';
import SMSearchPagerView from 'components/search/SMSearchPagerView';
import SMCategorySearchFilterView from './SMCategorySearchFilterView';
import SMSearchListSortView from 'components/search/SMSearchListSortView';
import SMFeatureRoomView from 'components/features/SMFeatureRoomView';
import SMFeatureStaffView from 'components/features/SMFeatureStaffView';
import SMRestClient from 'lib/SMRestClient';
import SMRenderHelper from 'components/helpers/SMRenderHelper';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMUserResource from 'resources/SMUserResource';
import sprintf from 'sprintf';
import SMSearchListTableRow from 'components/search/SMSearchListTableRow';
import SMUFavoriteListSelectView from 'components/dashboard/users/SMUFavoriteListSelectView';

class SMCategoryListView extends React.Component {

  constructor(props) {
    super(props);

    this.canRequest = true;

    this.state = {
      listItems: this.props.rooms,
      links: SMRestClient.parseLinkString(this.props.linkString),
      hasRank: false,
      latestUpdatedFavoriteList: {},
      targetFavoriteRoom: {},
      isSMUFavoriteListSelectViewOpen: false,
    };
  }

  componentDidMount() {
    SMRenderHelper.addObserverForBaloon();
    if (location.search.search("sort") == -1 || location.search.search("sort=popular") == 1) {
      this.setState({hasRank: true});
    }
    SMTrackHelper.criteoList(this.props.currentUser ? this.props.currentUser.email : "", this.props.rooms);
  }

  // SMSearchListTableRow delegate
  updateFavoriteListState(favorite_list){
    this.setState({
      latestUpdatedFavoriteList: favorite_list
    });
  }

  // SMSearchListTableRow delegate
  favoriteDidSelect(favorable, isFavorite, rowIndex) {
    if (!this.props.currentUser) {
      SMAppHelper.redirectToLogin();
    }
    if (isFavorite) {
      // もしお気に入りに登録されている場合はリスト選択のモーダルを表示
      this.showFavoriteListSelectForm(favorable);
    } else {
      let room = favorable;
      let responseHandler = (data, error, xhr)=>{
        let listItems = this.state.listItems;
        if (error) {
          return;
        } else {
          room.is_favorite = true;
          room.registered_favorite_lists.push(data.favorite_list.id);
          listItems[rowIndex] = room;
          this.setState({
            listItems: listItems,
            latestUpdatedFavoriteList: data.favorite_list,
          });
        }
      };
      SMUserResource.postFavorite(this.props.currentUser.username, room.id, 'Room', responseHandler);
    }
  }

  showFavoriteListSelectForm(room, e){
    if (e) e.preventDefault();
    this.setState({
      targetFavoriteRoom: room,
      isSMUFavoriteListSelectViewOpen: true,
    });
  }

  // SMSearchListTableRow delegate
  favoriteListSelectViewDidClose() {
    this.setState({
      isSMUFavoriteListSelectViewOpen: false,
    });
  }

  sortDidChangeValue(value) {
    window.location.href = sprintf("%s?sort=%s", window.location.pathname, value);
  }

  render() {
    let rows = [];
    this.state.listItems.forEach((room, index) => {

      rows.push(
        <SMSearchListTableRow
          key={room.id}
          hasRank={(this.state.hasRank && this.props.currentPage == 1)}
          showBaloon={true}
          room={room}
          noRoomImage={this.props.noRoomImage}
          rowIndex={index}
          canSlide={true}
          delegate={this}
          latestUpdatedFavoriteList={this.state.latestUpdatedFavoriteList} />
      );
    });

    return(
      <div className="site-main">
        <div className="page__even page__padding">
          <div className="container">
            <div className="row">
              <div className="col-sm-12 col-md-8">
                <div className="search-list__sort">
                  <span className="service-select">
                    <SMSearchListSortView selectedValue={this.props.sort} delegate={this} />
                  </span>
                </div>
                <div className="search-list__head">
                  <div className="search-list__head-wrap">
                    <h1 className="search-list__head-title">{this.props.categoryTitle}</h1>
                    <span className="search-list__head-number">{this.props.totalCount}件</span>
                  </div>
                  <p className="search-list__head-description clear">{this.props.description}</p>
                  
                  <div className="units-list clear">
                    <ul ref="listContainer" className="row">
                      {rows}
                    </ul>
                  </div>
                  <SMSearchPagerView
                    delegate={this}
                    perPage={this.props.perPage}
                    totalCount={this.props.totalCount}
                    currentPage={this.props.currentPage}
                    links={this.state.links} />
                </div>
              </div>
              <div className="col-sm-12 col-md-4 sm-hide">
                <SMCategorySearchFilterView
                  location={this.props.location}
                  mediumLocation={this.props.mediumLocation}
                  keyword={this.props.keyword}
                  eventType={this.props.eventType}
                  capacity={this.props.capacity}
                  minCapacity={this.props.minCapacity}
                  maxCapacity={this.props.maxCapacity}
                  amenities={this.props.amenities}
                  spaceType={this.props.spaceType}
                  eventTypeList={this.props.eventTypeList}
                  capacityList={this.props.capacityList}
                  amenityList={this.props.amenityList}
                  spaceTypeList={this.props.spaceTypeList}
                  />
                <SMFeatureRoomView roomFeatures={this.props.roomFeatures} />
                <SMFeatureStaffView staffFeatures={this.props.staffFeatures} />
              </div>
            </div>
          </div>
        </div>
        <SMUFavoriteListSelectView
          room={this.state.targetFavoriteRoom}
          delegate={this}
          user={this.props.currentUser}
          isOpen={this.state.isSMUFavoriteListSelectViewOpen}
          listItems={this.state.favoriteLists}
          latestUpdatedFavoriteList={this.state.latestUpdatedFavoriteList}
          updateState={this.updateFavoriteListState.bind(this)}
          noFavoriteListImage={this.props.noFavoriteListImage} />
      </div>
    );
  }
}
export default SMCategoryListView;



// WEBPACK FOOTER //
// ./app/javascript/components/categories/SMCategoryListView.jsx